
/****
 * 手凤内页弹窗广告
 * ****/
import sdkTool from "If_AdTool/common/sdkTool";

import EventEmitter from "If_AdTool/common/EventEmitter";

function isIfeng() {
    return window.location.hostname.indexOf("ifeng.com") != -1
}
let COOKIE_EXPIRES = 43200;
let doaminList = ["igs.ifeng.com", "gs.ifeng.com", "ijx.ifeng.com", "jx.ifeng.com"];
function dayLimit(el, data) {
    if ( doaminList.indexOf(window.location.hostname) != -1 || allData.channel&&doaminList.indexOf(allData.channel.domain)!=-1){
        return;
    }
    try{
        //如果是地方站，屏蔽插屏
        if (window.allData.docData.searchPath.split("-")[0] == 200) {
            return;
        }
    }catch(e){}
    let newDate = new Date();
    let today = newDate.getFullYear()+"-" + (newDate.getMonth()+1)+"-"+newDate.getDate();
    let ap = data.aids[0].ap;
    let limtKey = "day_limit" + "_" + ap;
    let limtTimeKey = limtKey +"_"+"time";
    //首页一天一次，其他页一天4次
    let saveDay = sdkTool.cookie(limtKey);
    if (saveDay != today){
        if (ap == "41817") {
            setTimeout(function(){
                loadAd(el, data, limtKey, limtTimeKey);
            },20*1000);
        }else{
            loadAd(el, data, limtKey, limtTimeKey);
        }
    }else{
        let saveTime = sdkTool.cookie(limtTimeKey);
        if (ap == "41817") {
            setTimeout(function () {
                if (saveTime){
                    let now = Date.now();
                    if (now - saveTime> 12*3600*1000){
                        loadAd(el, data, limtKey, limtTimeKey);
                    }
                }else{
                    loadAd(el, data, limtKey, limtTimeKey);
                }
            },20*1000)
        }
    }
};
function loadAd(el, data, limtKey, limtTimeKey){
    let option = {
        expires: COOKIE_EXPIRES
    }
    if (isIfeng()) {
        option.domain = "ifeng.com";
    }
    window.IfengAmgr.pageData = window.IfengAmgr.pageData || {};//和downpop.js相关
    if (!window.IfengAmgr.pageData.hasOwnProperty("floatAdOpen")) {
        window.IfengAmgr.pageData.floatAdOpen = false;
    }
    let f_event = new EventEmitter();
    f_event.on("close", () => {
        window.IfengAmgr.pageData.floatAdOpen = false;
        console.log("floatAd close", window.IfengAmgr.pageData)
    })
    f_event.on("noAd", () => {
        window.IfengAmgr.pageData.floatAdOpen = false;
        console.log("noAd close", window.IfengAmgr.pageData)
    })
    window.IfengAmgr.pageData.floatAdOpen = true;
    window.IfengAmgr.show(el, { aids: [{ ...data.aids[0], "extCode": { "event": f_event } }] }, {
        RenderError: function (data, res) {
            f_event.emit("noAd RenderError");
        },
        DataCmp:function (adData) {
            for (let p in adData){
                let  item = adData[p];
                window.IfengAmgr.pageData.floatAdOpen = true;
                if (item.b==41){
                    //如果是百度
                    let tuidArr = ["u6806019", "u6806998", "u6809003", "u6870290", "u6884327", "u6884330","u6884331"];
                    (window.slotbydup = window.slotbydup || []).push(
                        {
                            // 广告关闭回调方法 一个页面只需要定义一个
                            closeAd: function (tu_index) {
                                // tuid_同页面内相同代码位id自增索引
                                tu_index = tu_index.split("_")[0];
                                if (tuidArr.indexOf(tu_index)!=-1){
                                    f_event.emit("close");
                                }
                                
                            },
                        },
                        {
                            // 广告关闭回调方法 一个页面只需要定义一个
                            noAd: function (tu_index, noadInfo) {
                                // tuid_同页面内相同代码位id自增索引
                                // 无广告返回原因{noadx: '联盟内部无广告返回状态码', queryid:'精确到本次检索的唯一id'}
                                // console.log(noadInfo);
                                tu_index = tu_index.split("_")[0];
                                if (tuidArr.indexOf(tu_index) != -1) {
                                    f_event.emit("noAd");
                                }
                            }
                        }
                    );
                }else{
                  
                }
                let newDate = new Date();
                let today = newDate.getFullYear() + "-" + (newDate.getMonth() + 1) + "-" + newDate.getDate();
                sdkTool.cookie(limtKey, today, option);
                sdkTool.cookie(limtTimeKey, Date.now(), option);
                break;
            }
        }
    });
}
if (typeof window.IfengAmgr != undefined) {
    window.IfengAmgr.tplLib.dayLimit = { render: dayLimit, version: "1.0.0" };
}